import React, { useState } from 'react';

import { Button, Icon, TextField } from '@gerdau/hefesto';
import { decodeJwt } from '../../../utils/tokenUtil';
import { RefreshAuthTokenService } from '../../../services/Auth';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { GetFlag } from '../../../utils/featureFlag';

function formatarTimestamp(timestamp?: number): string {
  if (!timestamp) {
    return '';
  }
  const timeStampToDate = new Date(timestamp);

  const day: string = String(timeStampToDate.getDate()).padStart(2, '0');
  const month: string = String(timeStampToDate.getMonth() + 1).padStart(2, '0');
  const year: number = timeStampToDate.getFullYear();

  const hours: string = String(timeStampToDate.getHours()).padStart(2, '0');
  const minutes: string = String(timeStampToDate.getMinutes()).padStart(2, '0');
  const seconds: string = String(timeStampToDate.getSeconds()).padStart(2, '0');

  return `${day}/${month}/${year} às ${hours}:${minutes}:${seconds}`;
}

type Props = {
  showModalRefreshToken: () => void;
};

export const ClockManager = ({ showModalRefreshToken }: Props) => {
  const clockManagerFlag = GetFlag('clock-manager');

  const refreshAuthTokenService = new RefreshAuthTokenService();
  const [isOpen, setIsOpen] = useState(true);

  const token = decodeJwt(refreshAuthTokenService.getToken() ?? '');

  const timeLeftHours = Math.round(
    ((token?.expiration ?? 0) - Date.now()) / 1000 / 60 / 60
  );
  const timeLeftMinutes = Math.round(
    ((token?.expiration ?? 0) - Date.now()) / 1000 / 60
  );
  const timeLeftSeconds = Math.round(
    ((token?.expiration ?? 0) - Date.now()) / 1000
  );

  const tokenTotalLife = Math.round(
    ((token?.expiration ?? 0) - (token?.createdAt ?? 0)) / 1000 / 60 / 60
  );

  if (!clockManagerFlag) {
    return null;
  }

  return (
    <div
      style={{
        fontSize: 16,
        background: '#fff',
        borderEndEndRadius: '0.5rem',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
        padding: '0.5rem',
        zIndex: 9999,
        display: 'block',
        position: 'fixed',
        top: 0,
        left: !isOpen ? -220 : 0
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          cursor: 'pointer',
          background: '#fff'
        }}
      >
        <Button
          name="closeClockManager"
          onClick={() => setIsOpen((prev) => !prev)}
          icon={
            !isOpen ? (
              <Icon option="ArrowRight" variant="primary" />
            ) : (
              <Icon option="X" variant="primary" />
            )
          }
          variant="none"
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'center'
        }}
      >
        <span style={{ fontWeight: 'bold' }}>Gestão de Tempo</span>
      </div>
      <div>
        <TextField
          label="Criação do token"
          helperText="Data e hora de criação do token"
          name="inputField"
          type="text"
          value={formatarTimestamp(token?.createdAt)}
          icon={<Icon option="Alert" />}
        />
        <TextField
          label="Expiração do token"
          helperText="Data e hora de expiração do token"
          name="inputField"
          type="text"
          value={formatarTimestamp(token?.expiration)}
          icon={<Icon option="Alert" />}
        />
        <TextField
          label="Tempo total do token"
          helperText="Tempo, em horas, de vida do token entre criação à expiração"
          name="inputField"
          type="text"
          value={`${tokenTotalLife}h`}
          icon={<Icon option="Alert" />}
        />
        <TextField
          label="Tempo restante do token"
          helperText="Tempo de vida do token até expirar"
          name="inputField"
          type="text"
          value={`${timeLeftHours}h ou ${timeLeftMinutes}m ou ${timeLeftSeconds}s `}
          icon={<Icon option="Alert" />}
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ fontWeight: 'bold', textAlign: 'center' }}>
          Controles de expiração
        </span>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button name="5second" type="button" onClick={showModalRefreshToken}>
            Exibir expiração {tokenTotalLife >= 24 ? 'externo' : 'interno'}
          </Button>
        </div>
      </div>
    </div>
  );
};
